<script setup>
import AdminLayout from '@/layouts/AdminLayout.vue'
import { organizationRolesApi } from '@/api/Roles/OrganizationRolesApi.js'
import { onMounted, ref } from 'vue'
import OrganizationRoleCard from '@/views/Admin/Roles/OrganizationRoleCard.vue'
import LoadingSpinner from '@/components/Spinners/LoadingSpinner.vue'
import { useAuthStore } from '@/stores/authStore.js'

const authStore = useAuthStore()
const org_roles = ref([])
const isLoading = ref(false)

/**
 * Loads roles from the API.
 */
onMounted(() => {
	isLoading.value = true
	organizationRolesApi.getRoles(onGetRoles)
})

/**
 * Handles the response from the API call to get roles.
 * @param p_response
 * @param p_error_eh
 */
function onGetRoles(p_response, p_error_eh)
{
	try
	{
		isLoading.value = false
		if (p_error_eh)
		{
			p_response.showErrorBanner()
		}
		else
		{
			org_roles.value = p_response.getData()
		}
	}
	catch (e)
	{
		if (authStore.isDeveloper) console.error(e)
	}

}

</script>

<template>
	<AdminLayout>
		<div class="flex flex-row items-center">
			<p class="admin-center-subtitle">All Roles</p>
		</div>
		<div class="text-sm text-grayscale-body">
			Control app access with defined roles and permissions.
		</div>

		<LoadingSpinner v-if="isLoading" />
		<div v-if="!isLoading">
			<!-- Table -->
			<div class="flex flex-row gap-4 flex-wrap mt-6 ">
				<OrganizationRoleCard v-for="role in org_roles" :key="role.id" :role_id="role.id" :label="role.role" :description="role.description"></OrganizationRoleCard>
			</div>
		</div>


	</AdminLayout>
</template>

<style scoped>

</style>